import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { LoginPage } from '../auth/login';

import { ProductProvider } from "../../providers/product/product";

import { Product } from '../../models/product.model';
import { Packshot } from '../../models/packshot.model';

import { PackshotsPage } from '../packshots/packshots';
import { QuizDetailPage } from '../quiz-detail/quiz-detail';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-product-detail',
  templateUrl: 'product-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ProductDetailPage {

  product: Product;
  err: string;
  loading: boolean;
  packshots: Array<string>;
  videoTimeWatch: number = 0; 
  videoPreviousTimeWatch: number = 0;
  videoDiffTimeWatch: number = 0;
  videoPointEverSend: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public productProvider: ProductProvider, private iab: InAppBrowser) {}

  getProduct() {
    this.loading = true;
    this.productProvider.getByID(this.navParams.get('id'))
      .subscribe(
        product => this.product = product,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openPackshots(packshots: Packshot[]) {
    this.navCtrl.push(PackshotsPage, {
      packshots: packshots
    });
  }

  openQuiz(id: number) {
    this.navCtrl.push(QuizDetailPage, {
      id: id
    });
  }

  async download(url, download_type = "") {
    this.loading = true;
    let addPoint = new Promise((resolve, reject) => {
      this.productProvider.download(this.product.id, download_type)
        .subscribe(
          product => resolve(product),
          error => reject(error)
        )
      });

    await addPoint.then(
      (product) =>  {
        this.product = new Product(product);
        this.loading = false;
        this.iab.create(url, '_system', 'location=no');
      }).catch(error => {
      if (error.status == 401) {
        this.disconnected();
      }
      this.err = error;

      this.loading = false;
    });
  }

  ionViewDidLoad() {
    this.getProduct();
  }

  videoPlay($event) {
    let $video = $event.srcElement

    if ((parseInt($video.currentTime) - this.videoPreviousTimeWatch > 1) || (parseInt($video.currentTime) - this.videoPreviousTimeWatch < -1)) {
      this.videoDiffTimeWatch += parseInt($video.currentTime) - this.videoPreviousTimeWatch
    }

    this.videoPreviousTimeWatch = parseInt($video.currentTime)

    let currentTime = parseInt($video.currentTime) - this.videoDiffTimeWatch

    if ((currentTime * 100 / parseInt($video.duration)) >  80 && !this.videoPointEverSend && this.product.animation) {
      this.videoPointEverSend = true;
      this.productProvider.watched(this.product.id, this.product.animation)
      .subscribe(
        product => {},
        error => {
          this.err = <any>error;
        }
      );
    }
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/product-detail/product-detail.ts